'use client';
/* Built In Imports */
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Button, Collapse, Flex } from '@chakra-ui/react';

import parser from 'html-react-parser';
import forEach from 'lodash/forEach';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';

/* Services */

/**
 * Renders parsed string for structured text ShortCode.
 *
 * @param {string} str - HTML string.
 * @param {string} className - Class Name
 * @param {string} region - Region of the page
 * @param {string} textAlign - Alignment of the page
 * @returns {ReactElement} Structured Text Parser Code component
 */
const StructuredTextParser = ({
  str,
  mt,
  ml,
  className,
  textAlign,
  region,
  lang,
  maxW,
  style,
  ...props
}) => {
  const allTags = ['readmore'];
  const [readMore, setReadMore] = useState(true);
  const structured = useRef();
  // const history = useHistory();
  if (textAlign && textAlign === 'center-align') {
    textAlign = 'center';
  }

  let innerText = '';
  let initialString = '';
  let startTagIndex = -1;

  // <a([^>]* )href=\"([^\"]+)\"
  const re = new RegExp('href="([^"]+)"', 'g');
  let strMatched = str?.match(re);
  if (strMatched?.length) {
    forEach(strMatched, function (matched) {
      matched = matched.replace('href=', '').replace(/"/g, '');
      str = str.replace(
        `"${matched}"`,
        `"${refineUrlDomain(matched, region, lang)}"`
      );
    });
  }

  forEach(allTags, function (tag) {
    let matched = str?.match(/\[(.*?)\]/g);
    if (matched?.length && matched[0].indexOf(tag) > -1) {
      startTagIndex = str.indexOf(matched[0]);
    }

    initialString = str?.substring(0, startTagIndex) || str;
    if (startTagIndex && startTagIndex > -1) {
      let endTagStartIndex = str.indexOf(`[/${tag}]`);
      let endTagEndIndex = endTagStartIndex + tag.length + 3;
      let tagTextString = str?.substring(startTagIndex, endTagEndIndex);
      innerText = tagTextString
        .replace(`[${tag}]`, '')
        .replace(`[/${tag}]`, '')
        .replace(matched[0], '');
    }
  });

  useEffect(
    () => () => {
      setReadMore(true);
    },
    [str]
  );

  return (
    <Box ref={structured}>
      <Box
        className={
          className || props?.theme === 'light'
            ? 'structured-content-light'
            : 'structured-content-dark'
        }
        m={{ base: '0 auto' }}
        mt={{ base: mt || '15px', md: mt || '15px', lg: mt || '15px' }}
        ml={{ base: ml || '0', md: ml || '0', lg: ml || '0' }}
        maxW={{
          base: '100%',
          md: maxW || '100%',
        }}
        textAlign={textAlign || 'left'}
        color="#0E1216"
        px={{ base: 2, md: '' }}
        {...props}
      >
        {initialString && parser(initialString)}

        {startTagIndex > -1 && (
          <Box
            as="p"
            maxW="100% !important"
            m={{ base: '0 auto' }}
            mt={{
              base: mt || '0',
              md: mt || '0',
            }}
            // pb="30px"
            textAlign={textAlign || 'left'}
          >
            <Collapse in={!readMore} animateOpacity duration={20000}>
              {/* <Box
              pb="30px"
              textAlign={textAlign || 'left'}
            > */}
              {parser(innerText)}
              {/* </Box> */}
            </Collapse>

            <Flex
              alignItems="center"
              justifyContent={'center'}
              textAlign={'center'}
              position="relative"
              mt="15px"
            >
              <Button
                variant="link"
                // display="flex"
                display={'inline-block'}
                alignItems={'center'}
                mb="20px"
                fontFamily="var(--FedraSansStd-medium)"
                bgColor="transparent"
                border={'none'}
                color={'#CA4E2A'}
                fontSize="16px !important"
                padding={'10px 35px'}
                textDecoration="none !important"
                transition="none !important"
                _hover={{
                  textDecoration: 'none',
                  bgColor: 'none',
                  color: '#983C21',
                }}
                textAlign="center"
                width={'200px'}
                onClick={() => setReadMore(!readMore ? true : false)}
                m={'0 auto'}
                _focus={{ boxShadow: 'none' }}
                mt={
                  readMore ? { base: '10px', sm: '10px', md: '-10px' } : '0px'
                }
              >
                <>{readMore ? 'More' : 'Less'} Details</>
                {readMore ? (
                  <ChevronDownIcon w={7} h={6} />
                ) : (
                  <ChevronUpIcon w={7} h={6} />
                )}
              </Button>
            </Flex>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StructuredTextParser;
